<template>
    <div class="vrm-notifications">
        <div
            v-for="notification in notifications"
            :key="notification.id"
            class="vrm-notifications__notification animate-repeat"
            :class="noteClass(notification)"
            :data-cy="notification.type + '-notification'"
            @click="noteClicked(notification)"
        >
            <button class="vrm-notifications__notification__close">
                <span class="sg-vrm-icon_060_cross-round-24px" />
            </button>
            <div class="vrm-notifications__notification__title">{{ noteTitle(notification) }}</div>
            <div class="vrm-notifications__notification__message" v-html="notification.message" />
        </div>

        <div
            v-if="!online && !offlineDismissed"
            :key="'offline_warning'"
            class="vrm-notifications__notification animate-repeat vrm-notifications__notification--danger"
            @click="offlineDismissed = true"
        >
            <button class="vrm-notifications__notification__close">
                <span class="sg-vrm-icon_060_cross-round-24px" />
            </button>
            <div class="vrm-notifications__notification__title">{{ $t('core.offline') }}</div>
            <div class="vrm-notifications__notification__message">
                {{ $t('core.offline_description') }}
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { WindowEventListener } from '@/vue/decorators/window-event-listener';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';
import { NOTIFICATIONS } from '@/vue/store/modules/notifications';

const DISMISS_MINUTES = 5;

@Component
@AngularDirective('vrm-notifications')
@AngularLocaleBundle('core')
@AngularLocaleBundle('common')
class VrmNotifications extends Vue {
    online = true;
    offlineSince = null;
    offlineDismissed = false;

    created() {
        this.online = window.navigator.onLine;
    }

    @WindowEventListener('online', window.document.body)
    onOnline() {
        console.info('[VrmNotifications] browser has gone online');
        this.online = true;
    }

    @WindowEventListener('offline', window.document.body)
    onOffline() {
        console.info('[VrmNotifications] browser has gone offline');
        this.online = false;
        if (this.offlineSince + 60000 * DISMISS_MINUTES < Date.now()) {
            this.offlineDismissed = false;
        }
        this.offlineSince = Date.now();
    }

    /**
     * @returns {VrmNotification[]}
     */
    get notifications() {
        return this.$store.getters[NOTIFICATIONS.GET_ALL];
    }

    /**
     * @param {VrmNotification} notification
     */
    noteClicked(notification) {
        this.$store.dispatch(NOTIFICATIONS.REMOVE, notification);
    }

    /**
     * @param {VrmNotification} notification
     * @returns {string}
     */
    noteClass(notification) {
        return `vrm-notifications__notification--${notification.type}`;
    }

    /**
     * @param {VrmNotification} notification
     * @returns {string}
     */
    noteTitle(notification) {
        return notification.title.length
            ? notification.title
            : this.$t(`common.${notification.type}`);
    }
}
export default VrmNotifications;
</script>
